import type { ProductSize } from '@/types'

/** Stable key for a cart / checkout line (product + variant). */
export function cartLineKey(productId: string, size?: ProductSize): string {
  return `${productId}-${size || 'default'}`
}
